import { Paragraph } from '@eggplant/pattern-library'

const NotificationEnvelopeDescription = () =>
  <Paragraph>
    An email address used for bounces.
  </Paragraph>

export default NotificationEnvelopeDescription
